import * as React from "react";
import Title from "../../../../../common/title/title";
import Input from "../../../../../common/input_text/input_text";
import { DroneDTO } from "../../../../../store/drone_slice";

interface RentalAvailabilityProps {
  droneData: Partial<Omit<DroneDTO, "id">>;
  updateDroneData: (newData: Partial<Omit<DroneDTO, "id">>) => void;
}

const RentalAvailability: React.FC<RentalAvailabilityProps> = ({
  droneData,
  updateDroneData,
}) => {
  const handleAvailabilityChange = (value: string) => {
    updateDroneData({ extraDetails: value });
  };

  return (
    <div className="w-full max-w-2xl mx-auto mt-8 px-4">
      <Title
        title="Before we finalize...when can people start renting?"
        subtitle="You can use this calendar to specify the start date of your advertisement and indicate any dates when the item is unavailable for rental."
      />
      <div className="mt-6">
        <Input
          value={droneData.extraDetails || ""}
          onChange={handleAvailabilityChange}
          placeholder="Tuesday and Friday all day. Mondays between 7 pm and 8 pm."
          isTextarea={true}
          rows={6}
          maxLength={500}
        />
      </div>
    </div>
  );
};

export default RentalAvailability;
